import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { creationModalKeys } from "app/pages/activation/components/RankWidget/dataAutomationKeys";
import { modalsTexts } from "app/pages/activation/components/RankWidget/texts";

import * as SC from "./styles";

export const InfoBanner = () => (
    <SC.Container data-automation={creationModalKeys.nameStep.banner}>
        <SC.InfoContainer>
            <SC.Title>{translate(modalsTexts.bannerTitle)}</SC.Title>

            <SC.Description>
                <SWReactIcons
                    iconName="email"
                    size="xs"
                    iconColor={colorsPalettes.blue[400]}
                />
                <span>{translate(modalsTexts.bannerDescription)}</span>
            </SC.Description>
        </SC.InfoContainer>

        <SC.TimeBadge>
            <SWReactIcons
                iconName="avg-visit-duration"
                size="xs"
                iconColor={colorsPalettes.blue[400]}
            />
            <span>{translate(modalsTexts.bannerTime)}</span>
        </SC.TimeBadge>
    </SC.Container>
);
